import { useArticleDelete } from '@/module/Author/Article';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface ArticleDeleteButtonProps {
  articleId: Id;
}

export function ArticleDeleteButton({ articleId }: ArticleDeleteButtonProps) {
  const mutation = useArticleDelete(articleId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
